module.exports = __webpack_public_path__ + "media/site/images/contact/contact_page_text-e2befa16b4c70730c630ac5868d17d8c.svg";